<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <section class="content-sectiton">
      <div class="container">
        <div class="login-signup alert-msg" style="width: 580px; margin-top: 123px; margin-bottom: 100px;">
          <div class="alert custom-alert" role="alert">
            <p>
              We have send link to reset your password in your Email.Please check your mail!!
            </p>
          </div> <!-- .alert -->
        </div>
      </div><!-- .content-inner -->
    </section>
  </nb-layout-column>
  <nb-layout-footer>
    <ngx-footer></ngx-footer>
  </nb-layout-footer>
</nb-layout>